import contactWarpupCodes from '../config/wrapupCodes.json';
import standardWrapupCodes from '../config/standardWrapupCodes.json';
import autodrop from '../config/autoDrop.json';
import maskNumbersData from '../config/maskNumber.json';
import CallbackData from '../config/callbacks.json';
import WisdomData from '../config/wisdom.json';
import BreakAndLunch from '../config/breakAndLunch.json';
import EmailSender from '../config/emailSender.json';





export function savetolocal(Key:string,data:any,ContactID:string){
	let CurrentStorage  = JSON.parse(localStorage.getItem(Key)||"{}")
	if(!CurrentStorage[ContactID]){
		CurrentStorage[ContactID] = data || ""
		localStorage.setItem(Key, JSON.stringify(CurrentStorage));
	}
}

export function Updatelocal(Key:string,data:any,ContactID:string){
	let CurrentStorage  = JSON.parse(localStorage.getItem(Key)||"{}")
	CurrentStorage[ContactID] = data
	localStorage.setItem(Key, JSON.stringify(CurrentStorage));
}

export function deletelocal(Key:string,ContactID:string){
	let CurrentStorage  = JSON.parse(localStorage.getItem(Key)||"{}")
	delete CurrentStorage[ContactID]
	localStorage.setItem(Key, JSON.stringify(CurrentStorage));
}

export function deletealllocal(Key:string){
	localStorage.removeItem(Key);
}






export const millisecondsToHMS = (milliseconds:any) => {
	const seconds = Math.floor((milliseconds / 1000) % 60);
	const minutes = Math.floor((milliseconds / 1000 / 60) % 60);
	const hours = Math.floor((milliseconds / 1000 / 60 / 60) % 24);

	const formattedTime = [
		hours.toString().padStart(2, "0"),
		minutes.toString().padStart(2, "0"),
		seconds.toString().padStart(2, "0")
	].join(":");
	return formattedTime;
}

export const secondsToHMS = (totalSeconds:number) => {
	if(totalSeconds === 0 || totalSeconds === undefined){
		return "00:00:00";
	}
	const seconds = Math.floor((totalSeconds) % 60);
	const minutes = Math.floor((totalSeconds / 60) % 60);
	const hours = Math.floor((totalSeconds / 60 / 60));

	const formattedTime = [
		hours.toString().padStart(2, "0"),
		minutes.toString().padStart(2, "0"),
		seconds.toString().padStart(2, "0")
	].join(":");
	return formattedTime;
}

export const millisecondsToSeconds = (milliseconds:any) => {
	const seconds = Math.floor((milliseconds / 1000) % 60);
	return seconds
}

export const getContactAccountName = (queueTitle:any) => {
	let account:any = "";
	if (!queueTitle) { return console.warn("CustomCCP::WrapCode", "No queue name found for contact?! Aborting wrap code display.")}
	else if (queueTitle.startsWith("Husq")) account = "Husqvarna" 
	else if (queueTitle.startsWith("Mobility")) account = "Mobox" 
	else if (queueTitle.startsWith("Schneider")) account = "Schneider" 
	else if (queueTitle.startsWith("Whitbread")) account = "Whitbread"
	else if (queueTitle.startsWith("Carl Zeiss")) account = "Zeiss"
	else if (queueTitle.startsWith("McDonalds")) account = "McDonalds"
	else if (queueTitle.startsWith("Schindler")) account = "Schindler"
	else if (queueTitle.startsWith("Loreal")) account = "Loreal"
	else if (queueTitle.startsWith("Legrand")) account = "Legrand"
	else if (queueTitle.startsWith("Ask Fujitsu")) account = "AskFujitsu"
	else if (queueTitle.startsWith("Lowell")) account = "Lowell"
	else if (queueTitle.startsWith("Somfy")) account = "Somfy"
	else if (queueTitle.startsWith("Sharp")) account = "Sharp"
	else if (queueTitle.startsWith("Audi")) account = "Audi"
	else if (queueTitle.startsWith("Idemia")) account = "Idemia"
	else if (queueTitle.startsWith("SGN")) account = "SGN"
	else if (queueTitle.startsWith("TMS")) account = "TMS"
	else if (queueTitle.startsWith("Total Saphir")) account = "TotalSaphir"
	else if (queueTitle.startsWith("Total Osiris")) account = "TotalOsiris"
	else if (queueTitle.startsWith("HM ")) account = "HM"
	else if (queueTitle.startsWith("DWS")) account = "DWS"
	else if (queueTitle.startsWith("BAT")) account = "BAT"
	else if (queueTitle.startsWith("PZC")) account = "PZC"
	else if (queueTitle.startsWith("ING")) account = "ING"
	else if (queueTitle.startsWith("Centrica")) account = "Centrica"
	else if (queueTitle.startsWith("Bridgestone")) account = "Bridgestone"
	else if (queueTitle.startsWith("Mitsubishi") || queueTitle.startsWith("PKPE")) account = "Mitsu"
	else if (queueTitle.startsWith("SSD LODZ Mitsubishi")) account = "Mitsu"
	else if (queueTitle.startsWith("POL02 O2")) account = "Telefonica"
	else if (queueTitle.startsWith("Inside Sales")) account = "InsideSales"
	else if (queueTitle.startsWith("Road Safety Authority")) account = "RoadSafetyAuthority"
	else if (queueTitle.startsWith("Cargotec")) account = "Cargotec"
	else account = "AllOthers";
	return account;
}

export const getWrapupCode = (account:string, contactDirection:string, region:string) => {
	const standarizedRegions = standardWrapupCodes.regions;

	let wrapupCode:any;
	let result:any = {wrapupCodes:[], subAccounts:[]};

	if(standarizedRegions.includes(region)) {
		result.wrapupCodes = standardWrapupCodes.wrapupCodes;
		result.subAccounts = [];

	} else {
		wrapupCode = contactWarpupCodes.filter((code:any) => code.acountName === account)[0]

		if(contactDirection === "inbound") {
			result.wrapupCodes = (wrapupCode.wrapupCodes[0].inbound) ? wrapupCode.wrapupCodes[0].inbound : [];
			result.subAccounts = [];
		} else if(contactDirection === "outbound") {
			result.wrapupCodes = (wrapupCode.wrapupCodes[0].outbound) ? wrapupCode.wrapupCodes[0].outbound : [];
			result.subAccounts = (account === 'Mobox') ? wrapupCode.wrapupCodes[0].suboutbound : []
		}
	}
	return result
}

export const getAutodropTime = (queueName: string, channel:string) => {
	if(autodrop.autodropChannels.includes(channel)) {
		let autodropTime = autodrop.autodropTimes
					.filter((item:any) => queueName.startsWith(item.prefix))
					.map((queue:any) => queue.time)[0]
		return autodropTime;
	} else {
		return 0
	}
}

export const getMaskNumbersData = (profileName:string) => {
	
	let elements = maskNumbersData.maskNumber.filter((item:any) => profileName.startsWith(item.AccountName))[0]
	if(elements) {
		return elements.listOfElements
	} else {
		return []
	}
}

export const postCallbackID = async (username:string, CBNumber:string) => {
	let body = JSON.stringify({"Agent":username,"CBNumber":CBNumber})
	const resp = await fetch(process.env.REACT_APP_API_GETWAY_URL + "SetCBNumber", {
		method: "POST",
		headers: {'Content-Type': 'application/json',"Access-Control-Allow-Origin": "*"},
		body: body,
	});
	if (!resp.ok) throw new Error("Non 200 response: " + resp.status);
	return true
}

export const getVMAccountForRPName = async (profileName: string) => {
    if (profileName.startsWith("BAT COS01 Support Staff")) return undefined;
    if (profileName.startsWith("Support Staff BAT/Reynolds")) return undefined;
    if (profileName.startsWith("Primark")) return "Primark";
    if (profileName.startsWith("BAT")) return "BAT";
    if (profileName.startsWith("HM ")) return "HM";
    if (profileName.startsWith("Damm")) return "Damm";
	if (profileName.startsWith("ING")) return "ing";
    if (profileName.startsWith("Wabco")) return "WabcoWurth";
    return undefined;
}

export const getCallbackTableName = async (profileARN:any) => {
	if (!profileARN) return;
    if (profileARN === CallbackData.SANDBOX_CALLBACK_RPS ) return "sandbox";
    if (CallbackData.LOREAL_CALLBACK_RPS.includes(profileARN)) return "loreal";
    if (CallbackData.BRIDGESTONE_CALLBACK_RPS.includes(profileARN)) return "bridgestone";
    if (CallbackData.USCALE_CALLBACK_RPS.includes(profileARN)) return "uscale";
	if (CallbackData.ING_CALLBACK_RPS.includes(profileARN)) return "ing";
	if (CallbackData.ERICSSON_CALLBACK_RPS.includes(profileARN)) return "ericsson";
	if (CallbackData.MultiClient_CALLBACK_RPS.includes(profileARN)) return "multiclientdesk";
	if (CallbackData.AWS_CALLBACK_RPS.includes(profileARN)) return "aws";
	if (CallbackData.GabsCallbackTesting_CALLBACK_RPS.includes(profileARN)) return "gabs";
	if (CallbackData.FAYAT_CALLBACK_RPS.includes(profileARN)) return "fayat";
    return;
}

export const checkWisdomEnabled = async (profileName:string) => {
	let result = WisdomData.CustomerProfile.filter((item:any) => profileName.includes(item))
	return (result.length > 0) ? true : false;
}

export const getBreakAndLunchTime = async (profileName:string) => {
	return BreakAndLunch.filter((item:any) => profileName.startsWith(item.profileName))[0]
}

export const getEmailSenderList = async (profileName:string) => {
	return EmailSender.filter((item:any) => profileName === item.routingProfileName)[0]
}
